var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 34.15C28.6833 34.15 29.0417 34.0083 29.325 33.725C29.6083 33.4417 29.75 33.0833 29.75 32.65V15.3C29.75 14.9 29.6083 14.5583 29.325 14.275C29.0417 13.9917 28.6833 13.85 28.25 13.85C27.8167 13.85 27.4583 13.9917 27.175 14.275C26.8917 14.5583 26.75 14.9167 26.75 15.35V22.4H21.25V15.3C21.25 14.9 21.1083 14.5583 20.825 14.275C20.5417 13.9917 20.1833 13.85 19.75 13.85C19.3167 13.85 18.9583 13.9917 18.675 14.275C18.3917 14.5583 18.25 14.9167 18.25 15.35V23.9C18.25 24.3333 18.3917 24.6917 18.675 24.975C18.9583 25.2583 19.3167 25.4 19.75 25.4H26.75V32.7C26.75 33.1 26.8917 33.4417 27.175 33.725C27.4583 34.0083 27.8167 34.15 28.25 34.15ZM9 42C8.2 42 7.5 41.7 6.9 41.1C6.3 40.5 6 39.8 6 39V9C6 8.23333 6.3 7.54167 6.9 6.925C7.5 6.30833 8.2 6 9 6H39C39.7667 6 40.4583 6.30833 41.075 6.925C41.6917 7.54167 42 8.23333 42 9V39C42 39.8 41.6917 40.5 41.075 41.1C40.4583 41.7 39.7667 42 39 42H9ZM9 39H39V9H9V39ZM9 9V39V9Z",
    fill: "#2B2B2B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.897474fd82a3e7a491f928095a8d0451.svg";
export { ForwardRef as ReactComponent };